export default {
    computed: {
        family () {
            return this.$store.getters['family/getFamily'];
        },
        nativeWarehouse () {
            return this.family.native_warehouse;
        },
        chosenWarehouse () {
            return this.family.chosen_warehouse;
        },
        anotherChosenWarehouse () {
            if (this.nativeWarehouse && this.chosenWarehouse) {
                return this.nativeWarehouse.warehouse_id !== this.chosenWarehouse.warehouse_id;
            }
            return null;
        },
        supportingWarehouses () {
            if (!this.hasGiftGiverAndHigherStatus) {
                const result = [];
                if (this.family.warehouses != null) {
                    this.family.warehouses.forEach((el) => {
                        if (this.nativeWarehouse) {
                            if (el.warehouse_id !== this.nativeWarehouse.warehouse_id) {
                                result.push(el);
                            }
                        } else {
                            result.push(el);
                        }
                    });
                }
                return result;
            }
            return [];
        }
    }
};
